import {IPut} from "../interfaces/requests";
import {api} from "utils/service";

export const axiosPut = <Model>({url, data}: IPut<Model>) => {
  return api.put(url, data);
};
